import {
  AddEditProjectOverview,
  AddEditQualityChecklist,
  AddEditSafetyChecklist,
  AddTaskCategory,
  EditPlan,
  ProjectBasicDtl,
  ProjectOverview,
  ProjectPlan,
  QualityChecklist,
  SafetyChecklist,
  TaskCategory,
  TeamAssignment,
} from "@/pages";
import { routes } from "../utils";

export const ProjectOverviewRoutes = () => {
  return {
    path: routes.projectOverview,
    children: [
      {
        path: "",
        element: <ProjectOverview />,
      },
      {
        path: routes.id + "/" + routes.action,
        children: [
          {
            path: routes.projectPlan,
            children: [
              {
                path: routes.planId + "/" + routes.planAction,
                element: <EditPlan />,
              },
            ],
          },
        ],
      },
      {
        path: routes.add,
        element: <AddEditProjectOverview />, // Parent tab container
        children: [
          {
            path: routes.projectInfo,
            element: <ProjectBasicDtl />,
          },
          {
            path: routes.taskCategory,
            children: [
              {
                path: "",
                element: <TaskCategory />,
              },
              {
                path: routes.add,
                element: <AddTaskCategory />,
              },
              {
                path: routes.tabRowId + "/" + routes.tabRowAction,
                element: <AddTaskCategory />,
              },
            ],
          },
          {
            path: routes.qualityChecklist,
            children: [
              {
                path: "",
                element: <QualityChecklist />,
              },
              {
                path: routes.add,
                element: <AddEditQualityChecklist />,
              },
              {
                path: routes.tabRowId + "/" + routes.tabRowAction,
                element: <AddEditQualityChecklist />,
              },
            ],
          },
          {
            path: routes.safetyChecklist,
            children: [
              {
                path: "",
                element: <SafetyChecklist />,
              },
              {
                path: routes.add,
                element: <AddEditSafetyChecklist />,
              },
              {
                path: routes.tabRowId + "/" + routes.tabRowAction,
                element: <AddEditSafetyChecklist />,
              },
            ],
          },
          {
            path: routes.teamAssignment,
            element: <TeamAssignment />,
          },
        ],
      },
      {
        path: routes.id + "/" + routes.action,
        element: <AddEditProjectOverview />, // Parent tab container
        children: [
          {
            path: routes.projectInfo,
            element: <ProjectBasicDtl />,
          },
          {
            path: routes.taskCategory,
            children: [
              {
                path: "",
                element: <TaskCategory />,
              },
              {
                path: routes.add,
                element: <AddTaskCategory />,
              },
              {
                path: routes.tabRowId + "/" + routes.tabRowAction,
                element: <AddTaskCategory />,
              },
            ],
          },
          {
            path: routes.qualityChecklist,
            children: [
              {
                path: "",
                element: <QualityChecklist />,
              },
              {
                path: routes.add,
                element: <AddEditQualityChecklist />,
              },
              {
                path: routes.tabRowId + "/" + routes.tabRowAction,
                element: <AddEditQualityChecklist />,
              },
            ],
          },
          {
            path: routes.safetyChecklist,
            children: [
              {
                path: "",
                element: <SafetyChecklist />,
              },
              {
                path: routes.add,
                element: <AddEditSafetyChecklist />,
              },
              {
                path: routes.tabRowId + "/" + routes.tabRowAction,
                element: <AddEditSafetyChecklist />,
              },
            ],
          },
          {
            path: routes.teamAssignment,
            element: <TeamAssignment />,
          },
          {
            path: routes.projectPlan,
            children: [
              {
                path: "",
                element: <ProjectPlan />,
              },
            ],
          },
        ],
      },
    ],
  };
};
